// extracted by mini-css-extract-plugin
module.exports = {"pageStyle":"UnasssignSupervisorPopup_pageStyle__1xUQA","dialogCard":"UnasssignSupervisorPopup_dialogCard__3CG0b"};